import { render, staticRenderFns } from "./AddNewOutsourcing.vue?vue&type=template&id=6f6d8a33&"
import script from "./AddNewOutsourcing.vue?vue&type=script&lang=js&"
export * from "./AddNewOutsourcing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports